import React from 'react'
import { Button, Form, Modal } from 'react-bootstrap'

const DeleteUserModal = (props) => {
  return (
    <Modal show={true} size="md" centered onHide={props.handleClose}>
        <Modal.Header closeButton className="CNSHeader">
          <h3 className="titleMd uppercase m-0">Delete {props?.deleteEmployer ? "Employer" : "Employee"}</h3>
        </Modal.Header>
        <Form noValidate>
          <Modal.Body className="">
            <div className="basicInfoWrapper newServiceFormWrapper">
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Are you sure to delete this {props?.deleteEmployer ? "employer" : "employee"}</Form.Label>
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer className="CNSFooter">
            <Button variant="secondary" onClick={props.handleClose}>
              Close
            </Button>
            <Button
              variant="success"
              type="button"
              onClick={props.deleteUser}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
  )
}

export default DeleteUserModal
